import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "@/components/common/WhatsAppFab";
import SiteHead from "@/components/common/SiteHead";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-parchment-grain text-noir">
      <SiteHead />
      <Header />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
